module.exports = __webpack_public_path__ + "img/17.64241ca5.jpg";